
import Vue from "vue";
import Component from "vue-class-component";
import { C } from "../controller";

const TabInfoProps = Vue.extend({});

@Component({})
export default class TabInfo extends TabInfoProps {
  get withAcompte() {
    return C.withAcompte();
  }
}
